import { gql } from 'urql';
import { HighSchoolTeamInviteFragment, HighSchoolTeamInviteListFragment } from '../../../../generated/spin-graphql';
import { DeleteIcon } from '../../../svg/DeleteIcon';
import { BackIcon } from '../../../svg/BackIcon';
import { useCallback, useMemo, useState } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { EditHighSchoolTeamFormData } from '../../../common/modals/dashboard/my-teams/HighSchoolEditTeamPopup';

gql`
    mutation DeleteHighSchoolTeamInvites($inviteIds: [uuid!]!) {
        delete_espin_team_invite(where: { id: { _in: $inviteIds } }) {
            affected_rows
        }
    }

    fragment HighSchoolTeamInvite on espin_team_invite {
        id
        status
        user {
            player_profile {
                id
                spin_username
            }
        }
        player_profile {
            id
            spin_username
        }
    }
`;

enum InviteStatus {
    PENDING = 'Pending',
    CANCELLED = 'Cancelled Invite',
}

type InviteData = {
    member: HighSchoolTeamInviteFragment;
    status: InviteStatus;
};

export function HighSchoolEditableTeamInviteList({
    inviteList,
    register,
    setVal,
}: {
    inviteList: HighSchoolTeamInviteListFragment;
    register: UseFormRegister<EditHighSchoolTeamFormData>;
    setVal: (val: string[]) => void;
}) {
    const setInitialInviteStatuses = useMemo(() => {
        return inviteList.team_invites.length > 0
            ? inviteList.team_invites.map((member) => {
                  return {
                      member,
                      status: InviteStatus.PENDING,
                  };
              })
            : [];
    }, [inviteList]);
    const [playerInviteStatuses, setPlayerInviteStatuses] = useState<InviteData[]>(setInitialInviteStatuses);

    const handleStatusChange = useCallback(
        (playerId) => {
            const updatedPlayers = playerInviteStatuses.map((player) =>
                player.member.id === playerId
                    ? {
                          ...player,
                          status:
                              player.status === InviteStatus.PENDING ? InviteStatus.CANCELLED : InviteStatus.PENDING,
                      }
                    : player,
            );
            setPlayerInviteStatuses(updatedPlayers);
            setVal(updatedPlayers.filter((p) => p.status === InviteStatus.CANCELLED).map((p) => p.member.id));
        },
        [playerInviteStatuses, setPlayerInviteStatuses, setVal],
    );

    return (
        <>
            {inviteList.team_invites.length > 0 && (
                <>
                    <p className="title-label">INVITED PLAYERS</p>
                    <div className="players-list">
                        {inviteList.team_invites.map((member) => (
                            <div
                                className="player-card"
                                key={`team-member-${
                                    member.user?.player_profile?.id ?? member.player_profile?.id ?? ''
                                }`}
                            >
                                <div className="player-info">
                                    {member.user?.player_profile?.spin_username ?? member.player_profile?.spin_username}
                                    <i>
                                        (
                                        {playerInviteStatuses.length > 0 &&
                                            playerInviteStatuses.filter((p) => p.member.id === member.id)[0].status}
                                        )
                                    </i>
                                </div>
                                <div className="controls-container">
                                    {playerInviteStatuses.length > 0 &&
                                        playerInviteStatuses.filter((p) => p.member.id === member.id)[0].status ===
                                            InviteStatus.PENDING && (
                                            <button
                                                className="red-circle-button control-button"
                                                onClick={() => handleStatusChange(member.id)}
                                            >
                                                <DeleteIcon />
                                            </button>
                                        )}
                                    {playerInviteStatuses.length > 0 &&
                                        playerInviteStatuses.filter((p) => p.member.id === member.id)[0].status ===
                                            InviteStatus.CANCELLED && (
                                            <button
                                                className="red-circle-button control-button"
                                                onClick={() => handleStatusChange(member.id)}
                                            >
                                                <BackIcon />
                                            </button>
                                        )}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
            <input type="hidden" {...register('invites_to_remove')} />
        </>
    );
}
